import {useShowUI} from "../../services/common";


const Footer = () => {
	const showUi = useShowUI();

	if (!showUi) {
		return null;
	}

	return (
		<div className="footer">
			<div className="container">
				@2021 City University of Hong Kong. All Rights Reserved.
			</div>
		</div>
	);
}

export default Footer;
